export const updateOrAppendById = <T, K extends keyof T>(
  items: T[],
  incoming: T,
  idKey: K
): T[] => {
  const index = items.findIndex((item) => item[idKey] === incoming[idKey]);

  if (index === -1) return [...items, incoming];

  return items.map((item, i) => (i === index ? incoming : item));
};
